import { render } from "./BlFormFieldVoice.vue?vue&type=template&id=fb61ebe2&scoped=true"
import script from "./BlFormFieldVoice.vue?vue&type=script&lang=js"
export * from "./BlFormFieldVoice.vue?vue&type=script&lang=js"

import "./BlFormFieldVoice.vue?vue&type=style&index=0&id=fb61ebe2&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb61ebe2"]])

export default __exports__